import { ITranslationValue } from "@evennt-tech/api-v2-core";
import { TranslationValues } from "ts/app/translation";

export const toTranslationValues = (
  translations: ITranslationValue[] | undefined | null
): TranslationValues =>
  (translations ?? []).reduce<TranslationValues>(
    (acc, { languageCode, text }) => {
      acc[languageCode] = text ?? "";
      return acc;
    },
    {}
  );
